'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const defaultLogger = console;

exports.defaultLogger = defaultLogger;
//# sourceMappingURL=logger.js.map
